<template>
  <div class="row justify-content-center">
    <div class="col-lg-5 col-md-7">
      <div class="card shadow border-0">
        <!-- <div class="card-header bg-transparent pb-5">
          <div class="text-muted text-center mt-2 mb-3">
            <small>{{ $t(this.$route.name+'.welcomeMsg') }}</small>
          </div>
          <div class="btn-wrapper text-center">
            <a href="#" class="btn btn-neutral btn-icon">
              <span class="btn-inner--icon"
                ><img src="static/img/icons/common/github.svg"
              /></span>
              <span class="btn-inner--text">Github</span>
            </a>
            <a href="#" class="btn btn-neutral btn-icon">
              <span class="btn-inner--icon"
                ><img src="static/img/icons/common/google.svg"
              /></span>
              <span class="btn-inner--text">Google</span>
            </a>
          </div>
        </div> -->
        <div class="card-body px-lg-5 py-lg-5">
          <div class="text-center text-muted mb-4">
            {{ $t(this.$route.name+'.credentialAsk') }}
          </div>
          <form role="form" name="form" v-on:submit.prevent="handleLogin">
            <!-- Username -->
            <div class="form-group" :class="{ error: v$.user.username.$errors.length }">
              <base-input
                formClasses="input-group-alternative mb-3"
                v-bind:placeholder="$t(this.$route.name+'.username')"
                addon-left-icon="ni ni-email-83"
                v-model="v$.user.username.$model"
              >
              </base-input>
                <!-- error message -->
              <div class="input-errors" v-for="(error, index) of v$.user.username.$errors" :key="index">
                <div class="error-msg">{{$t(error.$message)}}</div>
              </div>
            </div>

            <!-- password -->
            <div class="form-group" :class="{ error: v$.user.password.$errors.length }">
              <base-input
                formClasses="input-group-alternative mb-3"
                v-bind:placeholder="$t(this.$route.name+'.password')"
                type="password"
                addon-left-icon="ni ni-lock-circle-open"
                v-model="v$.user.password.$model"
              >
              </base-input>
                <!-- error message -->
              <div class="input-errors" v-for="(error, index) of v$.user.password.$errors" :key="index">
                <div class="error-msg">{{$t(error.$message)}}{{error.$params.min}}</div>
              </div>
            </div>

            <!-- <base-checkbox class="custom-control-alternative">
              <span class="text-muted">{{ $t(this.$route.name+'.rememberMe') }}</span>
            </base-checkbox> -->
            
            <div v-if="error == 'disabled'">
              {{message}}
              <form role="form" name="form" v-on:submit.prevent="handleResendEmail">
                <!-- resend email -->
                <div class="form-group" :class="{ error: v$.email.$errors.email }">
                  <base-input
                    formClasses="input-group-alternative has-danger"
                    v-bind:placeholder="$t($route.name+'.email')"
                    type="text"
                    addon-left-icon="ni ni-email-83"
                    v-model="v$.email.$model"
                  >
                  </base-input>
                    <!-- error message -->
                  <div class="input-errors" v-for="(error, index) of v$.email.$errors" :key="index">
                    <div class="error-msg"><small>{{$t(error.$message)}}</small></div>
                  </div>
                </div>

                <div class="text-center">
                  <base-button 
                    type="primary" 
                    native-type="submit"
                    class="my-4"
                    :disabled="v$.email.$invalid">
                    {{ $t(this.$route.name+'.resendEmail') }}
                  </base-button>
                </div>
              </form>
            </div>
            <div v-else-if="error == 'credential'">
              
              {{message}}

            </div>
            <div class="text-center">
              <base-button type="primary" native-type="submit" class="my-4" :disabled="v$.user.$invalid">{{ $t(this.$route.name+'.signInButton') }}</base-button>
            </div>
            
          </form>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-6">
          <a href="#" class="text-light" @click="modals.modal3 = true"><small>{{ $t(this.$route.name+'.forgotPass') }}</small></a>
        </div>
        <div class="col-6 text-right">
          <router-link to="/register" class="text-light"
            ><small>{{ $t(this.$route.name+'.createNewAccount') }}</small></router-link
          >
        </div>
      </div>
    </div>
    
  <modal :show="modals.modal3"
        body-classes="p-0"
        modal-classes="modal-dialog-centered modal-sm">
      <card type="secondary" shadow
            header-classes="bg-white pb-5"
            body-classes="px-lg-4 py-lg-5"
            class="border-0"
      >
            <h2>{{ $t(this.$route.name+'.forgotPassTitle') }}</h2>
            
            <div v-if="forgotPassEmailSent==false">
              <span>{{ $t(this.$route.name+'.forgotPassDescription') }}</span>
              <form role="form" v-on:submit.prevent="handleForgotPassword">
                <div class="form-group" :class="{ error: v$.email.$errors.length }">
                  <base-input
                    formClasses="input-group-alternative has-danger"
                    v-bind:placeholder="$t($route.name+'.email')"
                    addon-left-icon="ni ni-email-83"
                    v-model="v$.email.$model">
                  </base-input>
                
                  <!-- error message -->
                  <div class="input-errors" v-for="(error, index) of v$.email.$errors" :key="index">
                    <div class="error-msg">{{$t(error.$message)}}</div>
                  </div>
                </div>
                  <div class="text-center">
                      <base-button 
                        type="primary"
                        native-type="submit"
                        class="btn btn-block my-4"
                        :disabled="v$.email.$invalid">
                      {{ $t(this.$route.name+'.forgotPassButton') }}
                      </base-button>
                  </div>
              </form>
            </div>
            <div v-else>
              {{ this.message }}
            </div>
            <base-button 
              type="primary"
              class="btn btn-block btn-warning"
              v-on:click="this.modals.modal3=false;this.forgotPassEmailSent=true"
              >
            {{ $t(this.$route.name+'.cancelButton') }}
            </base-button>
      </card>
  </modal>
</div>
</template>
<script>
import User from '../../models/user';
import LandlordService from '@/services/landlord.service'

import Modal from "@/components/Modal.vue";
import useVuelidate from '@vuelidate/core'
import { required, minLength, helpers, email } from '@vuelidate/validators'

export default {
  name: "login",
  setup () {
    return { v$: useVuelidate() }
  },
  components: {
    Modal
  },
  validations() {
    return {
      user: {
        username: {
          required: helpers.withMessage(this.$route.name+'.errorFieldRequired', required),
        },
        password: {
          required: helpers.withMessage(this.$route.name+'.errorFieldRequired', required),
          min: helpers.withMessage(this.$route.name+'.errorInvalidLength', minLength(6)),
        }
      },
      email: {
        required_custom: helpers.withMessage(this.$route.name+'.errorFieldRequired', required),
        email: helpers.withMessage(this.$route.name+'.errorFieldEmail', email),
      },
    }
  },
  methods : {
    handleLogin() {
      if (this.user.username && this.user.password) {
        this.$store.dispatch('auth/login', this.user).then(
          response => {
            LandlordService.getLandlordById(response.user.id).then( 
              landlord => {
                localStorage.setItem('landlord', JSON.stringify(landlord));
                
                this.$router.push('/dashboard');
              },
              error => {
                this.errors.push(error);
              }
            );
          },
          error => {
            if(error.response.status == 401){
              if(error.response.data.detail.includes("disabled")){
                this.error = "disabled";
                this.message = this.$t(this.$route.name+'.adviceActiveAccount');
              }else if(error.response.data.detail.includes("username")){
                this.error = "credential"
                this.message = this.$t(this.$route.name+'.errorCredentials')
              }
            }
          }
        );
      }
    },
    
    handleResendEmail(){
      
      // TBD
    },
    handleForgotPassword(){
      this.$store.dispatch('auth/forgotPassword', this.email).then(
        () => {
          this.forgotPassEmailSent = true;
          this.message = this.$t(this.$route.name+'.emailAlreadySent');
        },
        error => {
          console.log(error)
          if(error.response.status == 404){
            this.message = this.$t(this.$route.name+'.emailNotRegistered');
          }
        }
      );      
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  created() {
    if (this.loggedIn) {
      this.$router.push('/dashboard');
    }
  },
  data() {
    return {
      user: new User(null, null),
      message: "",
      error: null,
      email: null,
      modals: {
        modal3: false
      },
      forgotPassEmailSent: false,
    }
  },
};
</script>
<style></style>
